<div class="about-container">
    <h1>About</h1>
    <p>
        <strong>MAG</strong> is a decision support system designed to assist innovators, farmers, and value chain stakeholders in 
        developing, assessing, and optimizing sustainable business models within dynamic value chains.
    </p>
    <p>
        It was developed within the <strong>Radiant</strong>, focusing on enhancing the commercialization of underutilized 
        crops and improving the resilience of agrifood systems. BMDSS integrates business modeling tools, sustainability 
        assessment, and expert validation to ensure that business models are not only economically viable but also sustainable.
    </p>
    <p>
        BMDSS is powered by a structured, four-tier methodology, guiding users through business model conceptualization, 
        refinement, sustainability evaluation, and validation. It combines five core modules:
    </p>
    <ul>
        <li><strong>Lean Canvas</strong> for business ideation</li>
        <li><strong>TRL Assessment</strong> for evaluating technological readiness</li>
        <li><strong>Business Brief</strong> for structured model development</li>
        <li><strong>Sustainability Assessment</strong> covering economic, environmental, and social aspects</li>
        <li><strong>Expert Validation</strong> for final refinements</li>
    </ul>
    <p>
        The tool leverages Large Language Models running locally on our premises, ensuring data privacy and security by avoiding third-party LLM providers. It offers real-time recommendations, structured feedback, and iterative model refinements. Its modular architecture supports adaptability to evolving market and policy environments, enhancing decision-making agility and sustainability in agrifood value chains.
    </p>
    <p>MAG is powered by DEXiWare, a web application built around DEXi, a computer program for multi-attribute decision making. DEXi is aimed at interactive development of qualitative multi-attribute decision models and the evaluation of options. With DEXiWare, these models are available to end-users online.</p>
    <p>For more information visit <a target="_blank" href="https://dexiware.ijs.si">https://dexiware.ijs.si</a> or contact us at <a href="mailto:dexiware@ijs.si">dexiware&#64;ijs.si</a></p>    
    <p>To view MAG's terms of use and privacy policy click <a href="../../assets/pdf/Radiant_MAG_Terms_Conditions.pdf" target="_blank">here</a> and <a href="../../assets/pdf/Radiant_MAG_Privacy_Policy.pdf" target="_blank">here</a> respectively.</p>
    <p>This web tool is currently in beta. Version 1.0</p>    
    <p>_</p>

    <div class="bottom">    
        <h2>
            <img src="assets/icons/chainColor.svg"/>
        </h2>
        <h3>DEXiWare</h3>
        <button (click)="close()">CLOSE</button>
    </div>
</div>